export interface ISortFilter {
  sortBy: string;
  descending: boolean;
}

export interface IFieldFilter {
  filterBy: string;
  filterValue: string | string[];
}

export interface ISearchFilter {
  value?: string;
  headers: Array<ITableHeader>;
}

export interface ITableHeader {
  text: string;
  value: string;
  align?: string;
  sortable?: boolean;
  searchable?: boolean;
  editable?: boolean;
}

export interface IDropdownFilter {
  label: string;
  textPropName: string;
  valuePropName: string;
  filterType?: string;
  itemsModuleName: string;
  initialValue?: any;
  hasDefaultValue: boolean;
}

export class DropdownFilter implements IDropdownFilter {
  public label: string = '';
  public textPropName: string = 'name';
  public valuePropName: string = 'id';
  public itemsModuleName: string = '';
  public filterType?: string;
  public initialValue?: any;
  public hasDefaultValue: boolean = false;

  constructor(initData: Partial<DropdownFilter>) {
    Object.assign(this, initData);
  }
}

export interface ICustomOption {
  name: string;
  value: any;
}

export interface ICheckboxFilter {
  label: string;
}

export class CheckboxFilter implements ICheckboxFilter {
  public label: string = '';

  constructor(initData: Partial<CheckboxFilter>) {
    Object.assign(this, initData);
  }
}
